/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Info_PlayersInputs */



/**
* | output |
* | --- |
* | "Players" |
*
* @param {Tournament_Info_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_info_players = /** @type {((inputs?: Tournament_Info_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Info_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Joueurs")
	if (locale === "es") return /** @type {LocalizedString} */ ("Jugadores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Jogadores")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giocatori")
	return /** @type {LocalizedString} */ ("Players")
});